import React from 'react';
import {NewCaseForm} from './forms/NewCaseForm';
import {createNewCase} from '../features/thunks';
import {useDispatch} from 'react-redux';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from './ui/dialog';
import {Button} from './ui/button';
import {useAuth} from '@/util/auth';
import {PaymentPlanFeatures} from '@/constants';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger
} from '@/components/ui/alert-dialog';

const CreateCaseModal = () => {
    const [open, setOpen] = React.useState(false);
    const [showConfirmation, setShowConfirmation] = React.useState(false);
    const dispatch = useDispatch();
    const auth = useAuth();
    const formId = React.useId();

    return (
        <Dialog open={open} onOpenChange={(isOpen) => {
            if (!isOpen) {
                setShowConfirmation(true);
                return;
            }
            setOpen(isOpen);
        }}>
            <DialogTrigger asChild>
                <Button
                    disabled={!auth.isIncludedInSubscription(PaymentPlanFeatures.add_cases)}
                >
                    Add new case
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>New case</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <NewCaseForm
                        formId={formId}
                        onSubmit={(values) => {
                            dispatch(createNewCase({
                                title: values.case_name,
                                content: values.case_description,
                                key_question: values.key_question,
                                is_anonymous: values.is_anonymous
                            })).then(() => {
                                setOpen(false);
                            });
                    }}/>
                </div>
                <DialogFooter>
                    <AlertDialog open={showConfirmation}>
                        <AlertDialogTrigger asChild>
                            <Button type="button" variant="destructive" onClick={() => {
                                setShowConfirmation(true);
                            }}>Cancel</Button>
                        </AlertDialogTrigger>
                        <AlertDialogContent>
                            <AlertDialogHeader>
                                <AlertDialogTitle>Quit editing?</AlertDialogTitle>
                                <AlertDialogDescription>
                                    Changes you made so far will not be saved.
                                </AlertDialogDescription>
                            </AlertDialogHeader>
                            <AlertDialogFooter>
                                <AlertDialogCancel onClick={() => {
                                    setShowConfirmation(false);
                                }}>Cancel</AlertDialogCancel>
                                <AlertDialogAction onClick={() => {
                                    setOpen(false);
                                    setShowConfirmation(false);
                                }}>
                                    Continue
                                </AlertDialogAction>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialog>
                    <Button type="submit" form={formId}>Submit</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
};

export default CreateCaseModal;
